/// <amd-module name="SuiteCommerce.LookBook.LookItem.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookItem.Model", ["require", "exports", "Backbone", "Item.Model", "SuiteCommerce.LookBook.Common.Utils"], function (require, exports, Backbone_1, ItemModel, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookItemModel = void 0;
    var LookItemModel = /** @class */ (function (_super) {
        __extends(LookItemModel, _super);
        function LookItemModel(options) {
            var _this = _super.call(this, options) || this;
            _this.urlRoot = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/LookItem.Service.ss'));
            _this.set('item', new ItemModel(options.item));
            return _this;
        }
        LookItemModel.prototype.getName = function () {
            return this.get('name');
        };
        LookItemModel.prototype.getDescription = function () {
            return this.get('description');
        };
        LookItemModel.prototype.getLink = function () {
            return this.get('link');
        };
        LookItemModel.prototype.getImageId = function () {
            return this.get('imageid');
        };
        LookItemModel.prototype.getImage = function () {
            return this.get('image');
        };
        LookItemModel.prototype.getItem = function () {
            return this.get('item');
        };
        LookItemModel.prototype.getItemName = function () {
            return this.get('item').get('_name');
        };
        LookItemModel.prototype.getItemId = function () {
            return this.get('item').get('_id');
        };
        LookItemModel.prototype.getItemUrl = function () {
            return this.get('item').get('_url');
        };
        LookItemModel.prototype.getItemThumbnail = function () {
            return this.get('item').get('_thumbnail');
        };
        return LookItemModel;
    }(Backbone_1.Model));
    exports.LookItemModel = LookItemModel;
});
